'use client';

import * as React from 'react';
import { usePathname } from '@mentimeter/next-navigation';
import { IntercomProvider, useIntercom } from 'react-use-intercom';
import { usePrevious } from '@mentimeter/react-hooks';

interface Props {
  enableIntercom: boolean;
  intercomAppid: string;
}

const IntercomLoader = ({ enableIntercom, intercomAppid }: Props) => {
  if (!enableIntercom) {
    return null;
  }

  return (
    <IntercomProvider appId={intercomAppid} autoBoot={true}>
      <IntercomUpdater></IntercomUpdater>
    </IntercomProvider>
  );
};

const IntercomUpdater = () => {
  const { update } = useIntercom();
  const pathname = usePathname();
  const previousPathname = usePrevious(pathname);

  React.useEffect(() => {
    // for some reason in app router this effect triggers multiple times even when pathname is not changed
    // checking pathname against "previousPathname" so we can clearly see that pathname has changed
    // this issue is not related to React strict mode, probably some re-mounting of IntercomLoader
    if (!previousPathname || previousPathname === pathname) return;
    update();
  }, [update, pathname, previousPathname]);

  return null;
};

export default IntercomLoader;
